
export default function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/9cfb536fd7ac026b7b8bc10eda79862d.jpg"
          alt="Caribbean Fashion Fest"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <h1 className="text-6xl md:text-8xl lg:text-9xl font-light text-white mb-6 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
          Caribbean Fashion Fest
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-4 tracking-widest font-light">
          PUERTO PLATA
        </p>
        <p className="text-lg md:text-xl text-white/80 mb-12 max-w-2xl mx-auto font-light">
          Where Caribbean design meets global fashion
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={() => document.getElementById('tickets')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-10 py-4 bg-[#14B8A6] text-white text-sm tracking-widest hover:bg-[#0F9B8E] transition-all cursor-pointer whitespace-nowrap"
          >
            SECURE TICKETS
          </button>
          <button 
            onClick={() => document.getElementById('designers')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-10 py-4 border-2 border-white text-white text-sm tracking-widest hover:bg-white hover:text-black transition-all cursor-pointer whitespace-nowrap"
          >
            DESIGNER LINEUP
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/70"></i>
      </div>
    </section>
  );
}
